// extracted by mini-css-extract-plugin
export default {"mainContainer":"Login_mainContainer__6NKM3"};